import { z } from 'zod';

const viteEnvSchema = z.object({
  VITE_SUPABASE_URL: z.string().optional().default(''),
  VITE_SUPABASE_ANON_KEY: z.string().optional().default(''),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production', 'test']).optional().default('development'),
  VITE_RUNTIME_TARGET: z.enum(['desktop', 'web']).optional().default('web'),
  VITE_APP_PUBLIC_URL: z.string().optional().default(''),
  VITE_COPILOT_RUNTIME_URL: z.string().optional().default(''),
  VITE_COPILOT_MODEL: z.string().optional().default(''),
});

const parsed = viteEnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('Invalid Vite environment configuration.', parsed.error.flatten());
}

const fallback = {
  VITE_SUPABASE_URL: '',
  VITE_SUPABASE_ANON_KEY: '',
  VITE_APP_ENV: 'development' as const,
  VITE_RUNTIME_TARGET: 'web' as const,
  VITE_APP_PUBLIC_URL: '',
  VITE_COPILOT_RUNTIME_URL: '',
  VITE_COPILOT_MODEL: '',
};

export const env = parsed.success ? parsed.data : fallback;
export const isSupabaseConfigured = Boolean(env.VITE_SUPABASE_URL && env.VITE_SUPABASE_ANON_KEY);
